import * as React from "react";
import Box from "@mui/material/Box";
import WindPlot from "../wind";
import WeatherPlot from "../weather";
import PressurePlot from "../pressure";
import { a11yProps, CustomTabPanel, getStationData } from "../util";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

export default function Zuerichsee ({ forecast }) {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let [vmax_tal, speed_tal, dir_tal, t2m_tal, precip_tal, dursun_tal, twater_tal, qff_tal] = getStationData(forecast, "TAL", "lowerzurich", "QFF_KLO_GVE");
  let [vmax_mei, speed_mei, dir_mei, t2m_mei, precip_mei, dursun_mei, twater_mei, qff_mei] = getStationData(forecast, "MEI", "lowerzurich", "QFF_KLO_GVE");
  let [vmax_uer, speed_uer, dir_uer, t2m_uer, precip_uer, dursun_uer, twater_uer, qff_uer] = getStationData(forecast, "UER", "lowerzurich", "QFF_KLO_GVE");

  return (
    <div>
      <title>Zürichsee Windvorhersage - Surfwetter</title>
      <div className="App">
        <div className="Content">
          <h2>Zürichsee</h2>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs value={value} onChange={handleChange} aria-label="tabs" variant="fullWidth">
                <Tab label="Thalwil" {...a11yProps(0)} />
                <Tab label="Meilen" {...a11yProps(1)} />
                <Tab label="Üerikon, Risi" {...a11yProps(2)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <Box sx={{ overflow: "auto" }}>
                <WindPlot vmax={vmax_tal} speed={speed_tal} dir={dir_tal} />
                <PressurePlot qff={qff_tal} label="Zürich − Genf" label_plus="Bise" label_minus="Westwind" />
                <WeatherPlot t2m={t2m_tal} precip={precip_tal} sun={dursun_tal} twater={twater_tal} />
              </Box>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <Box sx={{ overflow: "auto" }}>
                <WindPlot vmax={vmax_mei} speed={speed_mei} dir={dir_mei} />
                <PressurePlot qff={qff_mei} label="Zürich − Genf" label_plus="Bise" label_minus="Westwind" />
                <WeatherPlot t2m={t2m_mei} precip={precip_mei} sun={dursun_mei} twater={twater_mei} />
              </Box>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <Box sx={{ overflow: "auto" }}>
                <WindPlot vmax={vmax_uer} speed={speed_uer} dir={dir_uer} />
                <PressurePlot qff={qff_uer} label="Zürich − Genf" label_plus="Bise" label_minus="Westwind" />
                <WeatherPlot t2m={t2m_uer} precip={precip_uer} sun={dursun_uer} twater={twater_uer} />
              </Box>
            </CustomTabPanel>
          </Box>
        </div>
      </div>
    </div>
  );
};
